import { useState, useEffect } from 'react';
import { useAppSelector } from './useAppSelector';
import { DEFAULT_COLOR_MODE } from '@/redux/slices/colorModeSlice';

/** Returns true when the active resolved color mode is dark. Reactive to system preference changes. */
export function useIsDark(): boolean {
  const mode = useAppSelector((s) => s.colorMode?.mode ?? DEFAULT_COLOR_MODE);
  const [systemDark, setSystemDark] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  useEffect(() => {
    if (mode !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setSystemDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [mode]);

  return mode === 'dark' || (mode === 'system' && systemDark);
}
